import React, { useContext, useMemo } from 'react';
import { shape } from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { formatDate } from '../../../helpers/QAHelper';
import { AnswerAQuestion } from '../../AnswerAQuestion/AnswerAQuestion.component';
import { Voting } from '../../Voting/Voting.component';
import { UserBadges } from './UserBadges';
import QAContext from '../../../context/QAContext';
import { getHighlightedText } from '../helpers/getHighlightedText';

export const AnswerContainer = ({ result, seoData }) => {
  const {
    UserNickname: resultNickName,
    SubmissionTime,
    QuestionSummary,
    AnswerIds: answerIds,
    Id: questionId,
  } = result;
  let { Answers, searchText, seoPageNumber } = useContext(QAContext);

  if (seoPageNumber && seoData) Answers = seoData;

  const filteredAnswers = useMemo(() => {
    if (Answers?.length) {
      return Answers.filter((answer) => {
        return answerIds.indexOf(answer.AnswerId) !== -1;
      });
    }

    return [];
  }, [Answers]);

  return (
    <div className="qa-result__answer">
      <AnswerAQuestion
        question={QuestionSummary}
        userName={resultNickName}
        askedDate={formatDate(SubmissionTime)}
        questionId={questionId}
      />
      {filteredAnswers?.length > 0
        && filteredAnswers.map((answer, index) => {
          const {
            Id,
            AnswerText,
            AuthorId,
            LastModificationTime,
            UserNickname,
            BadgesOrder,
            TotalPositiveFeedbackCount,
          } = answer?.Answer;

          return (
            <div className="qa-result__answer_container" key={index}>
              <Row>
                <Col xs={6} className="qa-result__answer--left">
                  <p>
                    <span className="qa-result__answer--bold">A:&nbsp; </span>
                    <span className="answer-text">
                      {getHighlightedText(Id, AnswerText, searchText)}
                    </span>
                  </p>
                  <div className="qa-title_info">
                    <span>by</span>
                    <span className="qa-result__answer_user">{UserNickname}</span>
                    <span className="date-divider">|</span>
                    <span>{formatDate(LastModificationTime)}</span>
                  </div>
                </Col>
                <Col xs={6} className="qa-result__answer--right">
                  <UserBadges badges={BadgesOrder} />
                </Col>
              </Row>
              <Voting totalPositiveFeedbackCount={TotalPositiveFeedbackCount} answerId={Id} />
            </div>
          );
        })}
    </div>
  );
};

AnswerContainer.displayName = 'AnswerContainer';

AnswerContainer.propTypes = {
  result: shape({}),
  seoData: shape([])
};

AnswerContainer.defaultProps = {
  result: {},
  seoData: null
};
